export default "__VITE_ASSET__DzwH2pbS__"